export const CUSTOMER_CURRENCY = 'USD' as const;

export const PROVIDER_CURRENCY_ALLOWLIST = [
  'USD',
  'EUR',
  'GBP',
  'RUB',
  'CNY',
  'KZT',
  'UAH',
] as const;

const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: CUSTOMER_CURRENCY,
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const providerNumberFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 6,
});

export function formatUsd(value: number): string {
  return usdFormatter.format(Number.isFinite(value) ? value : 0);
}

export function formatProviderAmount(value: number, currency?: string | null): string {
  const safeValue = Number.isFinite(value) ? value : 0;
  const normalizedCurrency = String(currency || '').trim().toUpperCase();

  if (
    PROVIDER_CURRENCY_ALLOWLIST.includes(
      normalizedCurrency as (typeof PROVIDER_CURRENCY_ALLOWLIST)[number],
    )
  ) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: normalizedCurrency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 6,
    }).format(safeValue);
  }

  if (/^[A-Z]{3}$/.test(normalizedCurrency)) {
    return `${providerNumberFormatter.format(safeValue)} ${normalizedCurrency} · валюта не поддерживается`;
  }

  return `${providerNumberFormatter.format(safeValue)} · валюта не указана`;
}

export function formatDateTime(value: string): string {
  if (!value) {
    return '—';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }

  return new Intl.DateTimeFormat('ru-RU', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}
